import React, { createContext, useContext, useEffect, useState } from "react";
import { useInventoryProductContext } from "../InventoryProductContext";
import { toast } from "react-toastify";
import { json } from "react-router-dom";
import { useTokenCallContext } from "../../TokenCall";

const AmazonInventoryCacheContext = createContext();

export const AmazonInventoryCacheProvider = ({ children }) => {
  const { currentUrl } = useTokenCallContext()
  const [products, setProducts] = useState([]);
  const [fetchAmazonInventoryData, setFetchAmazonInventoryData] = useState([]);
  const [inventoryFilteredProducts, setInventoryFilteredProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [isValidWithOTP, setIsValidWithOTP] = useState(false);
  const [uomData, setUomData] = useState([])
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  //   handle Filter
  const [updateApplyFilterOptions, setUpdateApplyFilterOptions] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedItemCategoryCode, setSelectedItemCategoryCode] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [combinedSelectedItems, setCombinedSelectedItems] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  //   Brand Data
  const [brandData, setBrandData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [packagingData, setPackagingData] = useState([]);
  const tokenData = localStorage.getItem("auth-token");
  //SKU
  const [selectedSku, setSelectedSku] = useState([]);
  const [skuData, setSkuData] = useState([]);
  //   Category
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [itemCategoryCodeData, setItemCategoryCodeData] = useState([]);

  // fetch selected data
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedItemCategoryCodes, setSelectedItemCategoryCodes] = useState(
    []
  );
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedPackaging, setSelectedPackaging] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleWidth = () => {
    setIsExpanded(!isExpanded);
  };
  // fetch Data ends

  //   Table input field
  const [requestedQuantities, setRequestedQuantities] = useState({});
  const [counterOffers, setCounterOffers] = useState({});

  // Filter Category Based on Filter
  const [newFilterData, setNewFilterData] = useState([])

  // Filter Condition UseState
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [showApplyFilterOptions, setShowApplyFilterOptions] = useState(false);
  const [isRealLoading, setIsRealLoading] = useState(false);

  // Amit 24-09-2024
  const [visibleColumns, setVisibleColumns] = useState([
    "new", "image", "sku", "brand", "productName", "upc",
    "availableQuantity", "requestedQuantity", "price", "msrp", "counterOffer"]
  );

  const cacheName = "test-inventory-cache";

  const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`;
  //Without Etag

  // const fetchAndCacheData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch data from server");
  //     }

  //     const data = await response.json();
  //     const cacheStorage = await caches.open(cacheName);
  //     await cacheStorage.put(
  //       `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`,
  //       new Response(JSON.stringify(data))
  //     );
  //     // console.log("Data stored in cache:", data);
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching and caching data:", error);
  //     throw error; // Propagate the error further
  //   }
  // };

  // const fetchDataFromCache = async () => {
  //   const cacheName = "test-inventory-cache";
  //   const cacheStorage = await caches.open(cacheName);
  //   const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`;

  //   try {
  //     const cachedResponse = await cacheStorage.match(cacheUrl);

  //     if (cachedResponse) {
  //       const cachedData = await cachedResponse.json();
  //       // console.log("Data fetched from cache:", cachedData);
  //       setProducts(cachedData); // Assuming `setProducts` is defined elsewhere
  //       return cachedData;
  //     } else {
  //       return await fetchAndCacheData();
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data from cache:", error);
  //     throw error; // Propagate the error further
  //   }
  // };

  const fetchMarketDataFromServer = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/data/fetch-market-data`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "OData-MaxVersion": "4.0",
          "OData-Version": "4.0",
          "Prefer": "odata.include-annotations"
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from server");
      }

      const marketData = await response.json();

      return marketData;
    }
    catch (error) {
      console.log("Error in loading the market data: ", error);
    }
  }


  const fetchAndCacheData = async (modifiedDate) => {

    try {
      const response = await fetch(cacheUrl, {
        method: "GET",
        headers: {
          "time-cached": modifiedDate,
          "Content-Type": "application/json",
          "OData-MaxVersion": "4.0",
          "OData-Version": "4.0",
          "Prefer": "odata.include-annotations"
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from server");
      }

      const newData = await response.json();
      const cacheStorage = await caches.open(cacheName);
      const cachedResponse = await cacheStorage.match(cacheUrl);

      let cachedData = cachedResponse ? await cachedResponse.json() : [];
      const cachedDataMap = new Map(cachedData.map(product => [product.productid, product]));

      // Update or add products based on the new data
      newData.forEach(product => {
        if (product.productid) {
          cachedDataMap.set(product.productid, product);
        }
      });

      // Convert the Map back to an array
      let finalData = Array.from(cachedDataMap.values());
    
      setProducts(finalData);
      // Store the final data in cache
      await cacheStorage.put(
        cacheUrl,
        new Response(JSON.stringify(finalData), {
          headers: {
            "etag": response.headers.get("ETag") || "",
            "time-cached": new Date().toISOString(), // Store the updated time when data was cached
          }
        })
      );

      // setProducts(finalData);
      setIsLoading(false);
      return finalData;
    } catch (error) {
      console.error("Error fetching and caching data:", error);
      setIsLoading(false);
      //throw error; // Propagate the error further
    }
  };
  const fetchDataFromServer = async (modifiedDate) => {
    setIsLoading(false);
    setIsRealLoading(true);
    try {
      let modifiedDate = "1999-01-01T00:00:00Z";
      // Fetch data from server with appropriate headers
      const response = await fetch(cacheUrl, {
        method: "GET",
        headers: {
          "If-Modified-Since": modifiedDate, // Use standard header if supported by server
          "Content-Type": "application/json",
          "OData-MaxVersion": "4.0",
          "OData-Version": "4.0",
          "Prefer": "odata.include-annotations"
        },
      });

      if (!response.ok) {
        //throw new Error(`Failed to fetch data from server: ${response.statusText}`);
        // console.log('Failed to fetch data from server: ${response.statusText}');
        return [];
      }
      const data = await response.json();
      //  // Amit 23-09-2024
      //  let marketMetaData = await fetchMarketData();
      //       const newProductItems = [];
      //       data?.forEach((productitem)=>{
      //           let tempproductitem = {...productitem};
      //               let marketJson = productitem.nyc_marketjson;
      //               marketMetaData?.market?.forEach((marketitem)=>{
      //                 let relatedcolumns = marketMetaData?.marketcolumn?.filter((columnitem)=> columnitem.market==marketitem.key);
      //                 relatedcolumns?.forEach((columnitem)=>{
      //                   let columnvalue = getFieldValue(marketJson,columnitem.marketbrand,columnitem.countrycode,columnitem.fieldtype);
      //                   tempproductitem[columnitem.columnkey] = columnvalue;
      //                   })
      //               })
      //               newProductItems.push(tempproductitem);
      //           })
      //   // console.log("new product",newProductItems);
      setProducts(data);
      // setProducts(data);
      const cacheStorage = await caches.open(cacheName);
      await cacheStorage.put(
        cacheUrl,
        new Response(JSON.stringify(data), {
          headers: {
            "etag": response.headers.get("ETag") || "", // ETag header for cache validation
            "time-cached": new Date().toISOString() // Store the time when data was cached
          }
        })
      );
      setIsRealLoading(false);
      return data;
    } catch (error) {
      // Log and handle errors
      console.error("Error fetching and caching data:", error);
      setIsRealLoading(false);
      //throw error; // Propagate the error further
    }
  };
  const fetchDataFromCache = async () => {
    setIsLoading(true);

    try {
      const cacheStorage = await caches.open(cacheName);
      const cachedResponse = await cacheStorage.match(cacheUrl);

      let modifiedDate = "1999-01-01T00:00:00Z"; // Default date in UTC
      let headers = {
        "time-cached": modifiedDate,
        "Content-Type": "application/json",
        "OData-MaxVersion": "4.0",
        "OData-Version": "4.0",
        "Prefer": "odata.include-annotations"
      };

      if (cachedResponse) {
        // Retrieve the headers and data
        const cachedData = await cachedResponse.json();
        if (!cachedData) { return await fetchDataFromServer(modifiedDate); }
        // console.log("Productdatanew",cachedData);
        //     // Amit 23-09-2024
        //     let marketMetaData = await fetchMarketData();
        //     const newProductItems = [];
        //     cachedData?.forEach((productitem)=>{
        //         let tempproductitem = {...productitem};
        //             let marketJson = productitem.nyc_marketjson;
        //             marketMetaData?.market?.forEach((marketitem)=>{
        //               let relatedcolumns = marketMetaData?.marketcolumn?.filter((columnitem)=> columnitem.market==marketitem.key);
        //               relatedcolumns?.forEach((columnitem)=>{
        //                 let columnvalue = getFieldValue(marketJson,columnitem.marketbrand,columnitem.countrycode,columnitem.fieldtype);
        //                 tempproductitem[columnitem.columnkey] = columnvalue;
        //                 })
        //             })
        //             newProductItems.push(tempproductitem);
        //         })
        // // console.log("new product",newProductItems);
        setProducts(cachedData);
        //setProducts(cachedData);
        setIsLoading(false);

        const cachedETag = cachedResponse.headers.get("ETag");
        if (cachedETag) {
          headers["If-None-Match"] = cachedETag;
        }

        const timeCached = cachedResponse.headers.get("time-cached");
        if (timeCached) {
          modifiedDate = new Date(timeCached).toISOString();
          headers["time-cached"] = modifiedDate;
        }


        // Make a request to the server, passing the modified date and ETag as headers
        const serverResponse = await fetch(cacheUrl, {
          method: "GET",
          headers: headers
        });

        if (serverResponse.status === 304 && cachedResponse) {
          // console.log("Data not modified on server, use cached data");
          const cachedData = await cachedResponse.json();
          // Amit 23-09-2024
          //      let marketMetaData = await fetchMarketData();
          //      const newProductItems = [];
          //      cachedData?.forEach((productitem)=>{
          //          let tempproductitem = {...productitem};
          //              let marketJson = productitem.nyc_marketjson;
          //              marketMetaData?.market?.forEach((marketitem)=>{
          //                let relatedcolumns = marketMetaData?.marketcolumn?.filter((columnitem)=> columnitem.market==marketitem.key);
          //                relatedcolumns.forEach((columnitem)=>{
          //                  let columnvalue = getFieldValue(marketJson,columnitem.marketbrand,columnitem.countrycode,columnitem.fieldtype);
          //                  tempproductitem[columnitem.columnkey] = columnvalue;
          //                  })
          //              })
          //              newProductItems.push(tempproductitem);
          //          })
          //  // console.log("new product",newProductItems);
          setProducts(cachedData);
          // setProducts(cachedData);
          setIsLoading(false);
          return cachedData;
        }

        if (serverResponse.ok) {
          // console.log("Data has changed on the server, update the cache");
          return await fetchAndCacheData(modifiedDate);
        }
      } else {
        // No data in cache, fetch from server if no data available
        {
          return await fetchDataFromServer(modifiedDate);
        }
        throw new Error("Failed to fetch data from server");
      }
    } catch (error) {
      console.error("Error fetching data from cache:", error);
      setIsLoading(false);
      //throw error; // Propagate the error further
    }
  };

  // useEffect(() => {
  //   fetchDataFromCache();
  // }, []);


  // Function to check the value in localStorage and update the state
  const checkValidWithOTP = () => {
    const storedValue = localStorage.getItem("callApiData");
    setIsValidWithOTP(storedValue === "true");
  };

  // useEffect to check when the component mounts and when localStorage changes
  useEffect(() => {
    // Check on component mount
    checkValidWithOTP();

    // Listen for localStorage changes (useful for multi-tab scenarios)
    const handleStorageChange = () => {
      checkValidWithOTP();
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect to react when validWithOTP changes to true
  useEffect(() => {
    if (isValidWithOTP) {
      // Trigger your desired action here
      // console.log("validWithOTP is true, triggering useEffect!");
      if (currentUrl === '/home/amazon-inventory') {
        fetchDataFromCache();
        if (algopixMarketList.length == 0) {
          console.log("Market Data Call")
          fetchMarketData();
        }
      }
      // You can add your function call or other logic here
    }
  }, [isValidWithOTP, currentUrl]);

  function getFieldValue(jsonArrayString, marketBrand, countryCode, fieldtype) {

    try {
  
      if (jsonArrayString == null) return "-";
      const jsonArray = JSON.parse(jsonArrayString);
      if (jsonArray.length == 0) return "-";
  
      // Find the object that matches the marketBrand and countryCode
      const marketObject = jsonArray.find(obj =>
        obj.marketBrand === marketBrand && obj.countryCode === countryCode
      );
  
      if (!marketObject) {
        return '-';
      }
  
      // Get the value based on the fieldtype
      switch (fieldtype) {
        case 1:
          // Price
          return (marketObject.offers?.NEW?.marketPrice?.amount ?? '0');
  
        case 2:
          //Sales per month in $
          let value = marketObject.marketSpecificData?.estimatedSalesRevenues?.amount;
          return value ? (value) : '0';
  
        case 3:
          //Sales per month transactions
          return marketObject.marketSpecificData?.estimatedUnitSold ?? '-';
  
        case 4:
          //URL listing
          return marketObject.offers?.NEW?.listingUrl ?? '-';
  
        case 5:
          //Rank
          const platformName = marketObject.marketBrand.toLowerCase(); // Assuming the platform name is marketBrand
          return marketObject.marketSpecificData?.[`${platformName}Categories`]?.[0]?.bestSellerRanking ?? '-';
  
        case 6:
          //Number of sellers
          return marketObject.marketSpecificData?.competition?.numberOfOffers ?? '-';
  
        case 7:
          return Math.ceil((marketObject.marketSpecificData?.estimatedUnitSold ?? 0) / 100);
  
        default:
          return '-';
      }
    } catch (error) {
      console.log("error in getFieldValue: " + error);
    }
  }

  const filterProductsByBrand = () => { return products.filter(product => product.nyc_soldtoamazon === true && product.strava_availablequantity > 0); };


  const fetchAndTransformData = async () => {
    let filteredData = filterProductsByBrand();
    let marketData = await fetchMarketDataFromServer();
    if (marketData != null) {
      let newProductItems = [];
      filteredData?.forEach((productitem) => {
        let tempproductitem = { ...productitem };
        let marketJson = productitem.nyc_marketjson;
        marketData?.market?.forEach((marketitem) => {
          let relatedcolumns = marketData?.marketcolumn?.filter((columnitem) => columnitem.market == marketitem.key);
          relatedcolumns?.forEach((columnitem) => {
            let columnvalue = getFieldValue(marketJson, columnitem.marketbrand, columnitem.countrycode, columnitem.fieldtype);
            tempproductitem[columnitem.columnkey] = columnvalue;
          })
        })
        tempproductitem.nyc_marketjson = null;
        tempproductitem.nyc_marketprices = null;
        newProductItems.push(tempproductitem);
      })
      filteredData = newProductItems;
    }
    setFetchAmazonInventoryData(filteredData);
  };

  useEffect(() => {
    fetchAndTransformData();
  }, [products]);


  // Algopix Data start


  const [showPopup, setShowPopup] = useState(false);
  const handleButtonClick = (upcNumber) => {
    setShowPopup(true);
    fetchAlgopixData(upcNumber);
  };

  const handleCloseClick = () => {
    setShowPopup(false);
    setAlgoPixdata(null);
    setAmazonData(null);
    setEbayData(null);
    setWalmartData(null);
  };

  const [algopixdata, setAlgoPixdata] = useState(null);
  const [amazonData, setAmazonData] = useState(null);
  const [ebayData, setEbayData] = useState(null);
  const [walmartData, setWalmartData] = useState(null);

  const fetchAlgopixData = async (upcNumber) => {
    // console.log("inside fetchAlgopixData", upcNumber);
    try {

      const url = `${process.env.REACT_APP_SERVER_URL}/api/atu/get-algopix-data?keywords=${upcNumber}`;


      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch token');
      }

      const data = await response.json();
      // console.log(data.result);
      setAlgoPixdata(data.result);
      const amazon = data.result.offers.find(offer => offer.marketBrand === 'AMAZON');
      const ebay = data.result.offers.find(offer => offer.marketBrand === 'EBAY');
      const walmart = data.result.offers.find(offer => offer.marketBrand === 'WALMART');

      // console.log(amazon);
      // console.log(ebay);
      // console.log(walmart);
      setAmazonData(amazon);
      setEbayData(ebay);
      setWalmartData(walmart);

    } catch (error) {
      // console.log("Erron", error)
    }
  };


  // Algopix Data End's


  // Filter Data Call

  const fetchProductData = (fetchAmazonInventoryData, labelKey, valueKey) => {
    const uniqueItems = new Set();
    return fetchAmazonInventoryData
      .map((product) => {
        const label = product[labelKey];
        const value = product[valueKey];
        if (!label || !value) return null;
        return { label: label, value: value };
      })
      .filter((item) => item !== null)
      .filter((item) => {
        if (!uniqueItems.has(item.label)) {
          uniqueItems.add(item.label);
          return true;
        }
        return false;
      });
  };
  const fetchUOMProductData = (products, labelKey, valueKey) => {
    const uniqueItems = new Map();

    return products
      .map((product) => {
        const label = product[labelKey];
        const value = product[valueKey];
        if (!label || !value) return null;

        // Normalize the label to lowercase for comparison
        const normalizedLabel = label.toLowerCase();

        if (!uniqueItems.has(normalizedLabel)) {
          // Store both the normalized label and all variants in the map
          uniqueItems.set(normalizedLabel, {
            label: label, // Original label case
            value: [value], // Store values as an array to accumulate variants
          });
        } else {
          // Append the variant to the existing entry
          uniqueItems.get(normalizedLabel).value.push(value);
        }

        return null; // Skip return to filter later
      })
      .filter((item) => item !== null)
      .concat(Array.from(uniqueItems.values()))
      .map((item) => {
        // Combine all variants into a single string, comma-separated
        return {
          label: item.label,
          value: Array.from(new Set(item.value)).join(", "), // Ensure uniqueness in case of duplicate values
        };
      });
  };


  const fetchCategoryProductData = (fetchAmazonInventoryData) =>
    fetchProductData(
      fetchAmazonInventoryData,
      "strava_categories@OData.Community.Display.V1.FormattedValue",
      "strava_categories@OData.Community.Display.V1.FormattedValue"
    );
  const fetchSubCategoryProductData = (fetchAmazonInventoryData) =>
    fetchProductData(
      fetchAmazonInventoryData,
      "strava_subcategories@OData.Community.Display.V1.FormattedValue",
      "strava_subcategories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchItemCategoryCodeData = (fetchAmazonInventoryData) =>
    fetchProductData(
      fetchAmazonInventoryData,
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue",
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"
    );
  const fetchBrandProductData = (fetchAmazonInventoryData) =>
    fetchProductData(fetchAmazonInventoryData, "nyc_brand", "nyc_brand");
  const fetchColorProductData = (fetchAmazonInventoryData) =>
    fetchProductData(fetchAmazonInventoryData, "nyc_color", "nyc_color");
  const fetchPackagingProductData = (fetchAmazonInventoryData) =>
    fetchProductData(fetchAmazonInventoryData, "nyc_packaging", "nyc_packaging");
  const fetchUomProductData = (products) =>
    fetchUOMProductData(products, "nyc_sizeuom", "nyc_sizeuom");

  const fetchFilterData = async (fetchAmazonInventoryData) => {
    const categoryData = fetchCategoryProductData(fetchAmazonInventoryData);
    const subCategoryData = fetchSubCategoryProductData(fetchAmazonInventoryData);
    const itemCategoryCodeData = fetchItemCategoryCodeData(fetchAmazonInventoryData);
    const brandData = fetchBrandProductData(fetchAmazonInventoryData);
    const colorData = fetchColorProductData(fetchAmazonInventoryData);
    const packagingData = fetchPackagingProductData(fetchAmazonInventoryData);
    const uomData = fetchUomProductData(products)
    fetchFilteredProducts()
    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData);
    setItemCategoryCodeData(itemCategoryCodeData)
    setBrandData(brandData);
    setColorData(colorData);
    setPackagingData(packagingData);
    setUomData(uomData);
  };

  useEffect(() => {
    fetchFilterData(fetchAmazonInventoryData);
  }, [fetchAmazonInventoryData]);

  //   handle Checkbox checked

  const handleCheckboxChange = (setSelectedItems) => (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item.value)) {
        return prevSelected.filter((value) => value !== item.value);
      } else {
        return [...prevSelected, item.value];
      }
    });
    // updateFilterData();
  };


  // const fetchFilteredProducts = async () => {
  //   try {
  //     // Convert selected filter values to numbers for comparison
  //     const categoryData = categorySelectedItems.map(item => Number(item.value));
  //     const subCategoryData = subCategorySelectedItems.map(item => Number(item.value));
  //     const itemCategoryData = itemCategoryCodeSelectedItems.map(item => Number(item.value));
  //     const brandCategoryData = brandSelectedItems.map(item => item.value); // Assuming brand is a string
  //     const colorSelectedData = colorSelectedItems.map(item => item.value); // Assuming color is a string

  //     // console.log("categorySelectedItems", categoryData);
  //     // console.log("subCategorySelectedItems", subCategoryData);
  //     // console.log("itemCategoryCodeSelectedItems", itemCategoryData);
  //     // console.log("brandSelectedItems", brandCategoryData);
  //     // console.log("colorSelectedItems", colorSelectedData);

  //     const filtered = fetchAmazonInventoryData.filter(
  //       (product) =>
  //         (!categoryData.length || categoryData.includes(product.strava_categories)) &&
  //         (!subCategoryData.length || subCategoryData.includes(product.strava_subcategories)) &&
  //         (!itemCategoryData.length || itemCategoryData.includes(product.strava_itemcategorycode)) &&
  //         (!brandCategoryData.length || brandCategoryData.includes(product.nyc_brand)) &&
  //         (!colorSelectedData.length || colorSelectedData.includes(product.nyc_color))
  //     );

  //     setInventoryFilteredProducts(filtered);
  //   } catch (error) {
  //     console.error("Error filtering products:", error);
  //   }
  // };
  const [newProduct, setNewProduct] = useState([]);
  const [filterByLast30Days, setFilterByLast30Days] = useState(false);
  const filternewProducts = () => {
    // const filtered = inventoryFilteredProducts.filter(product => product.nyc_receivedinlast30days === true)
    // // console.log("new product", newProduct)
    // setNewProduct(filtered);
    // setInventoryFilteredProducts(filtered);
    setFilterByLast30Days(true); // Toggle the filter state
  }

  useEffect(() => {
    if (filterByLast30Days) {
      fetchFilteredProducts();
    }
  }, [filterByLast30Days])

  const [exportExcelName, setExportExcelName] = useState(null);
  const [selectedUOM, setSelectedUOM] = useState('');


  const handleUOMChange = (event) => {
    setSelectedUOM(event.target.value);
    setIsRangeChanged(true)
  };
  const fetchFilteredProducts = async () => {
    try {
      const categoryData = new Set(selectedCategories);
      const subCategoryData = new Set(selectedSubCategories);
      const itemCategoryData = new Set(selectedItemCategoryCodes);
      const brandCategoryData = new Set(selectedBrands);
      const colorSelectedData = new Set(selectedColors);
      const packagingSelectedData = new Set(selectedPackaging);
      const skuData = new Set(selectedSku);
      // Ensure selectedUOM is an array and split it if necessary
      const uomArray = Array.isArray(selectedUOM) ? selectedUOM : selectedUOM.split(',').map(uom => uom.trim().toLowerCase());
      const uomSet = new Set(uomArray);

      // if (selectedCategories.length !== 0) {
      //   setExportExcelName(selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
      // } else if (selectedBrands.length !== 0) {
      //   setExportExcelName(selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
      // } else {
      //   setExportExcelName(null);
      // }


      if (filterByLast30Days) {
        if (selectedCategories.length !== 0) {
          setExportExcelName("New_" + selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
        } else if (selectedBrands.length !== 0) {
          setExportExcelName("New_" + selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
        } else {
          setExportExcelName("New");
        }
      } else {
        if (selectedCategories.length !== 0) {
          setExportExcelName(selectedCategories[0] + "_" + (selectedCategories?.[1] || ''));
        } else if (selectedBrands.length !== 0) {
          setExportExcelName(selectedBrands[0] + "_" + (selectedBrands?.[1] || ''));
        } else {
          setExportExcelName(null);
        }
      }

      // console.log("CatDataatat", categoryData);
      // console.log("subCategoryData", subCategoryData);
      // console.log("itemCategoryData", itemCategoryData);
      // console.log("brandCategoryData", brandCategoryData);
      // console.log("colorSelectedData", colorSelectedData);
      // console.log("selectedUOM", uomArray);

      // Perform filtering
      const filtered = fetchAmazonInventoryData.filter(product => {
        const productUOM = product.nyc_sizeuom?.toLowerCase();
        const matchesUOM = !uomSet.size || uomSet.has("") || uomSet.has(productUOM);
        /// SKU filtering logic for A stock and B stock
        let skuDatalogic = true; // Default to true if no specific stock filter is applied.

        const isAStockSelected = skuData.has("A Stock");
        const isBStockSelected = skuData.has("B Stock");

        // If both "A stock" and "B stock" are selected, show all products (no filtering on -B)
        if (isAStockSelected && isBStockSelected) {
          skuDatalogic = true;
        }
        // If "A stock" is selected but not "B stock", exclude products containing `-B`
        else if (isAStockSelected) {
          skuDatalogic = !product.productnumber.includes("-B");
        }
        // If "B stock" is selected but not "A stock", include products containing `-B`
        else if (isBStockSelected) {
          skuDatalogic = product.productnumber.includes("-B");
        }
        const matchesLast30Days = filterByLast30Days
          ? product.nyc_receivedinlast30days === true
          : true;
        return (
          (product.strava_availablequantity > 0) && matchesLast30Days &&
          (!categoryData.size || categoryData.has(product["strava_categories@OData.Community.Display.V1.FormattedValue"])) &&
          (!subCategoryData.size || subCategoryData.has(product["strava_subcategories@OData.Community.Display.V1.FormattedValue"])) &&
          (!itemCategoryData.size || itemCategoryData.has(product["strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"])) &&
          (!brandCategoryData.size || brandCategoryData.has(product.nyc_brand)) &&
          (!colorSelectedData.size || colorSelectedData.has(product.nyc_color)) &&
          (!packagingSelectedData.size || packagingSelectedData.has(product.nyc_packaging)) &&
          matchesUOM && skuDatalogic
        );
      });

      setInventoryFilteredProducts(filtered);
      setFetchCompleted(true);
      setUpdateApplyFilterOptions(true);
      // await fetchDataBasedOnConditions()
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };


  const fetchApplyFilteredProducts = async () => {
    try {
      // Convert selected filter values to appropriate types
      const categoryData = selectedCategories; // Assuming categories are integers
      const subCategoryData = selectedSubCategories; // Assuming subcategories are integers
      const itemCategoryData = selectedItemCategoryCodes; // Assuming item category codes are integers
      const brandCategoryData = selectedBrands;
      const colorSelectedData = selectedColors;
      const packagingSelectedData = selectedPackaging

      // console.log("CatDataatat",categoryData)
      // console.log("subCategoryData",subCategoryData)
      // console.log("itemCategoryData",itemCategoryData)
      // console.log("brandCategoryData",brandCategoryData)
      // console.log("colorSelectedData",colorSelectedData)

      // Perform filtering
      const filtered = products.filter(product => {
        return (
          product.strava_availablequantity > 0
            (!categoryData.length || categoryData.includes(product["strava_categories@OData.Community.Display.V1.FormattedValue"])) &&
          (!subCategoryData.length || subCategoryData.includes(product["strava_subcategories@OData.Community.Display.V1.FormattedValue"])) &&
          (!itemCategoryData.length || itemCategoryData.includes(product["strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"])) &&
          (!brandCategoryData.length || brandCategoryData.includes(product.nyc_brand)) &&
          (!colorSelectedData.length || colorSelectedData.includes(product.nyc_color)) &&
          (!packagingSelectedData.length || packagingSelectedData.includes(product.nyc_packaging)) &&
          (!skuData.length || skuData.includes(product.productnumber))
        );
      });

      setInventoryFilteredProducts(filtered);
      setFetchCompleted(true)
      // await fetchDataBasedOnConditions()
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };



  const clearAllFilters = () => {
    setFilterByLast30Days(false);
    setShowApplyFilterOptions(false);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedItemCategoryCodes([])
    setSelectedColors([]);
    setSelectedPackaging([]);
    setSelectedBrands([]);
    setIsRangeChanged(false)
    fetchDataFromCache();
    setSelectedUOM('');
    setIsSelectAllChecked(false);
    setSelectedSku([]);
    clearAllMarketFilter();
  };


  // Based on filter Fetching other filter

  // For Category


  const fetchAfterSelectFilterData = (selectedData, labelKey, valueKey) => {
    const uniqueItems = new Set();
    return selectedData
      .map((product) => {
        const label = product[labelKey];
        const value = product[valueKey];
        if (!label || !value) return null;
        return { label: label, value: value };
      })
      .filter((item) => item !== null)
      .filter((item) => {
        if (!uniqueItems.has(item.label)) {
          uniqueItems.add(item.label);
          return true;
        }
        return false;
      });
  };

  const fetchFilterCategoryProductData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_categories@OData.Community.Display.V1.FormattedValue",
      "strava_categories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterSubCategoryProductData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_subcategories@OData.Community.Display.V1.FormattedValue",
      "strava_subcategories@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterItemCategoryCodeData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(
      inventoryFilteredProducts,
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue",
      "strava_itemcategorycode@OData.Community.Display.V1.FormattedValue"
    );

  const fetchFilterBrandData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_brand", "nyc_brand");

  const fetchFilterPackagingData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_packaging", "nyc_packaging");

  const fetchFilterColorData = (inventoryFilteredProducts) =>
    fetchAfterSelectFilterData(inventoryFilteredProducts, "nyc_color", "nyc_color");




  // CategoryFilter
  const fetchCategoryData = async (inventoryFilteredProducts) => {
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setSubCategoryData(subCategoryData);
    setBrandData(brandData);
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // SubCategoryFilter
  const fetchSubCategoryData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setBrandData(brandData);
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // BrandFilter
  const fetchBrandData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setPackagingData(packagingData);
    setColorData(colorData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // ItemCategoryCode Filter
  const fetchItemCategoryData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setPackagingData(packagingData);
    setColorData(colorData);
  };

  // ColorFilter
  const fetchColorData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setPackagingData(packagingData);
    setItemCategoryCodeData(itemCategoryCodeData);
  };

  // PackagingFilter
  const fetchPackagingData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);

    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setItemCategoryCodeData(itemCategoryCodeData);
    setColorData(colorData)
  };

  // PackagingFilter
  const fetchAllData = async (inventoryFilteredProducts) => {
    const categoryData = await fetchFilterCategoryProductData(inventoryFilteredProducts);
    const subCategoryData = await fetchFilterSubCategoryProductData(inventoryFilteredProducts);
    const brandData = await fetchFilterBrandData(inventoryFilteredProducts);
    const itemCategoryCodeData = await fetchFilterItemCategoryCodeData(inventoryFilteredProducts);
    const colorData = await fetchFilterColorData(inventoryFilteredProducts);
    const packagingData = await fetchFilterPackagingData(inventoryFilteredProducts);
    setCategoryData(categoryData);
    setSubCategoryData(subCategoryData)
    setBrandData(brandData)
    setItemCategoryCodeData(itemCategoryCodeData);
    setColorData(colorData)
    setPackagingData(packagingData)
  };


  const fetchDataBasedOnConditions = async () => {
    const hasSelectedFilters = [
      selectedCategories,
      selectedSubCategories,
      selectedBrands,
      selectedItemCategoryCode,
      selectedColors,
      selectedPackaging
    ].some(filter => filter.length > 0);


    if (selectedCategories.length) {
      await fetchCategoryData(inventoryFilteredProducts);
    }

    if (selectedSubCategories.length) {
      await fetchSubCategoryData(inventoryFilteredProducts);
    }

    if (selectedBrands.length) {
      await fetchBrandData(inventoryFilteredProducts);
    }

    if (selectedItemCategoryCode.length) {
      // console.log("Year are here only")
      await fetchItemCategoryData(inventoryFilteredProducts);
    }

    if (selectedColors.length) {
      await fetchColorData(inventoryFilteredProducts);
    }

    if (selectedPackaging.length) {
      await fetchPackagingData(inventoryFilteredProducts);
    }

    if (!hasSelectedFilters) {
      await fetchAllData(inventoryFilteredProducts);
    }
  };


  useEffect(() => {
    if (fetchCompleted) {
      fetchDataBasedOnConditions()
      setFetchCompleted(false)
    }
  }, [fetchCompleted])


  // Top Filter End's here


  const [isRangeChanged, setIsRangeChanged] = useState(false);


  const [ranges, setRanges] = useState({
    nyc_msrp: [0, 1000],
    size: [0, 1000],
    price: [0, 1000],
  });
  const [minMax, setMinMax] = useState({
    nyc_msrp: [0, 1000],
    size: [0, 1000],
    price: [0, 1000],
  });

  useEffect(() => {
    const initRange = (type) => {
      const values = fetchAmazonInventoryData.map(product => parseFloat(product[type])).filter(value => !isNaN(value));
      const min = Math.min(...values);
      const max = Math.max(...values);
      return [min, max];
    };

    setRanges({
      nyc_msrp: initRange('nyc_msrp'),
      size: initRange('size'),
      price: initRange('price'),
    });

    setMinMax({
      nyc_msrp: initRange('nyc_msrp'),
      size: initRange('size'),
      price: initRange('price'),
    });
  }, [fetchAmazonInventoryData]);

  const setRange = (type, range) => {
    setRanges(prevRanges => ({ ...prevRanges, [type]: range }));
    setIsRangeChanged(true);
  };

  const handleFilter = () => {
    let filtered = inventoryFilteredProducts;
    Object.keys(ranges).forEach(type => {
      filtered = filtered.filter(product => {
        const value = parseFloat(product[type]);
        return value >= ranges[type][0] && value <= ranges[type][1];
      });
    });
    setInventoryFilteredProducts(filtered);
    // setIsRangeChanged(false);
  };


  useEffect(() => {
    if (fetchCompleted) {
      handleFilter();
      setFetchCompleted(false);
    }
  }, [fetchCompleted]);


  // Algopix code


  // Amit 23-09-2024 
  // function getFieldValue(jsonArrayString, marketBrand, countryCode, fieldtype) {

  //   try {

  //     if (jsonArrayString == null) return "-";
  //     const jsonArray = JSON.parse(jsonArrayString);
  //     if (jsonArray.length == 0) return "-";

  //     // Find the object that matches the marketBrand and countryCode
  //     const marketObject = jsonArray.find(obj =>
  //       obj.marketBrand === marketBrand && obj.countryCode === countryCode
  //     );

  //     if (!marketObject) {
  //       return '-';
  //     }

  //     // Get the value based on the fieldtype
  //     switch (fieldtype) {
  //       case 1:
  //         // Price
  //         return (marketObject.offers?.NEW?.marketPrice?.amount ?? '0');

  //       case 2:
  //         //Sales per month in $
  //         let value = marketObject.marketSpecificData?.estimatedSalesRevenues?.amount;
  //         return value ? (value) : '0';

  //       case 3:
  //         //Sales per month transactions
  //         return marketObject.marketSpecificData?.estimatedUnitSold ?? '-';

  //       case 4:
  //         //URL listing
  //         return marketObject.offers?.NEW?.listingUrl ?? '-';

  //       case 5:
  //         //Rank
  //         const platformName = marketObject.marketBrand.toLowerCase(); // Assuming the platform name is marketBrand
  //         return marketObject.marketSpecificData?.[`${platformName}Categories`]?.[0]?.bestSellerRanking ?? '-';

  //       case 6:
  //         //Number of sellers
  //         return marketObject.marketSpecificData?.competition?.numberOfOffers ?? '-';

  //       default:
  //         return '-';
  //     }
  //   } catch (error) {
  //     // console.log("error in getFieldValue: "+error);
  //   }
  // }

  const [selectedMarket, setSelectedMarket] = useState([]);// list of selected market
  const [appliedSelectedMarket, setAppliedSelectedMarket] = useState([]);// list if applied selected market
  const [algopixMarketList, setAlgopixMarketList] = useState([]);// total market list
  const [attributeMapping, setAttributeMapping] = useState([]);// market and column mapping list

  // Amit 23-09-2024
  async function fetchMarketData() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/optionsetData/get-market-data`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",

            "OData-MaxVersion": "4.0",
            "OData-Version": "4.0"
          },
          body: JSON.stringify({ tokenData })
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data from server");
      }

      const data = await response.json();
      // console.log("marketdata: ",data);
      setAlgopixMarketList(data.market);
      setAttributeMapping(data.marketcolumn);
      // Changes for Making market column visible by default
      setSelectedMarket(data.market);
      setAppliedSelectedMarket(data.market);
      let updatedVisibleColumn = [];
      updatedVisibleColumn = visibleColumns.filter(attr => !(attr.includes("amazon") || attr.includes("ebay") || attr.includes("walmart")));

      data.market.forEach((market) => {
        // Get attributes related to the market
        const relatedAttributes = data.marketcolumn.filter((obj) => obj.market == market.label);
        const filterRelatedAttributes = [];
        relatedAttributes.forEach((val) => { if (val.fieldtype == 1 || val.fieldtype == 3 || val.fieldtype == 4 || val.fieldtype == 7) { filterRelatedAttributes.push(val.columnkey) } })
        updatedVisibleColumn = [...updatedVisibleColumn, ...filterRelatedAttributes]
        setVisibleColumns(updatedVisibleColumn);
      })

      return data;


    } catch (err) {
      // console.log("error in fetching market data: ",err);
      return []
    }
  }
  // Amit 23-09-2024
  useEffect(() => {
    if (algopixMarketList.length == 0) {
      if (isValidWithOTP) {
        if (currentUrl === '/home/amazon-inventory') {
          fetchMarketData();
        }
      }
    }
  }, [products, isValidWithOTP, currentUrl])

  // Amit 17-09-2024
  // function to handle seclect of of market from filter options
  function handleMarketChange(market) {
    // console.log("inside handleMarketChange fucntion");
    // console.log("market",market);
    // console.log("selectedMarket",selectedMarket," lenght:",selectedMarket.length);
    var ispresent = selectedMarket.includes(market);
    // If all related attributes are in visibleArray, remove them; otherwise, add them
    if (ispresent) {
      // Remove market
      setSelectedMarket((prev) => prev.filter((item) => item.key != market.key));
    } else {
      let updatedSelectedMarket = [...selectedMarket]; // Create a new array by copying the existing one
      updatedSelectedMarket.push(market);

      // Limit max selected market to three
      while (updatedSelectedMarket.length > 3) {
        toast.warning(`You cannot select more than three Markets, Market- ${updatedSelectedMarket[0].key} has been removed`);
        updatedSelectedMarket.shift();
      }

      // console.log("include", updatedSelectedMarket.includes(market));
      // console.log("newSelectedMarket", updatedSelectedMarket);

      // Set the updated array to the state
      setSelectedMarket(updatedSelectedMarket);
    }
  }

  // Amit 17-09-2024
  // this function is to clear all market
  function clearAllMarketFilter() {
    // Remove all market columns from visible columns list
    setVisibleColumns((prev) => prev.filter(attr => !(attr.includes("amazon") || attr.includes("ebay") || attr.includes("walmart"))));
    // Clear all market
    setSelectedMarket([])
    setAppliedSelectedMarket([]);
  }

  // Amit 17-09-2024
  // function to apply market filter on table column
  function applyMarketFilter() {
    setAppliedSelectedMarket(selectedMarket);
    // Remove all market columns from visible columns list
    let updatedVisibleColumn = [];
    updatedVisibleColumn = visibleColumns.filter(attr => !(attr.includes("amazon") || attr.includes("ebay") || attr.includes("walmart")));

    selectedMarket.forEach((market) => {
      // Get attributes related to the market
      const relatedAttributes = attributeMapping.filter((obj) => obj.market == market.label);
      const filterRelatedAttributes = [];
      // Amit 24-09-2024
      relatedAttributes.forEach((val) => { if (val.fieldtype == 1 || val.fieldtype == 3 || val.fieldtype == 4 || val.fieldtype == 7) { filterRelatedAttributes.push(val.columnkey) } })
      updatedVisibleColumn = [...updatedVisibleColumn, ...filterRelatedAttributes]
      setVisibleColumns(updatedVisibleColumn);
    })
  }

  return (
    <AmazonInventoryCacheContext.Provider value={{
      fetchAmazonInventoryData, inventoryFilteredProducts,
      products,
      handleCheckboxChange,
      brandData,
      setBrandData,
      colorData,
      setColorData,
      packagingData,
      setPackagingData,
      selectedBrands,
      setSelectedBrands,
      selectedColors,
      setSelectedColors,
      selectedPackaging,
      setSelectedPackaging,
      //
      categoryData,
      selectedCategory,
      setSelectedCategory,
      subCategoryData,
      selectedSubCategory,
      itemCategoryCodeData,
      setSelectedSubCategory,
      selectedItemCategoryCode,
      setSelectedItemCategoryCode,

      selectedCategories,
      setSelectedCategories,
      selectedSubCategories,
      setSelectedSubCategories,
      selectedItemCategoryCodes,
      setSelectedItemCategoryCodes,

      inventoryFilteredProducts,
      fetchFilteredProducts,
      clearAllFilters,
      setRequestedQuantities, setCounterOffers,
      counterOffers, requestedQuantities,
      // addToCart,
      handleFilter,
      ranges,
      minMax,
      setRanges,
      setRange,
      isRangeChanged,
      setIsRangeChanged,
      fetchApplyFilteredProducts,
      // Algo Pix
      handleButtonClick,
      handleCloseClick,
      showPopup,
      algopixdata,
      amazonData,
      ebayData,
      walmartData,
      fetchAndTransformData,
      updateApplyFilterOptions, setUpdateApplyFilterOptions,
      setNewProduct,
      newProduct,
      filternewProducts,
      combinedSelectedItems, setCombinedSelectedItems, isClicked, setIsClicked,
      // Amit
      showApplyFilterOptions, setShowApplyFilterOptions, exportExcelName, uomData,
      selectedUOM, setSelectedUOM, handleUOMChange, isExpanded, setIsExpanded,
      toggleWidth, isSelectAllChecked, setIsSelectAllChecked, selectedSku,
      setSelectedSku,
      skuData,
      setSkuData,
      visibleColumns,
      setVisibleColumns,
      algopixMarketList,
      selectedMarket,
      setSelectedMarket,
      handleMarketChange,
      clearAllMarketFilter,
      applyMarketFilter,
      attributeMapping,
      appliedSelectedMarket,
      setAppliedSelectedMarket,
      // Amit 23-09-2024
      getFieldValue,
      setFilterByLast30Days,
      isLoading,
      isRealLoading
    }}>

      {children}
    </AmazonInventoryCacheContext.Provider>
  );
};

export const useAmazonInventoryCacheContext = () => {
  const context = useContext(AmazonInventoryCacheContext);
  if (context === undefined) {
    throw new Error('useAmazonInventoryCacheContext must be used within an AmazonInventoryCacheProvider');
  }
  return context;
};

